@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */
    --n-toast-container-padding: var(--n-space-padding-600);
    --n-toast-container-width: auto;
    --n-toast-container-width-min: calc(
      400px + var(--n-toast-container-padding) * 2
    );
    --n-toast-container-width-max: calc(
      400px + var(--n-toast-container-padding) * 2
    );
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  /* The portal is promoted to the top layer as a popover so toasts clear modal
     <dialog> overlays; neutralize the popover UA chrome and let clicks through.
     The inner .group elements position themselves (fixed) and inherit the layer. */
  .portal {
    position: fixed;
    inset: 0;
    width: auto;
    height: auto;
    margin: 0;
    border: 0;
    padding: 0;
    background: transparent;
    overflow: visible;
    pointer-events: none;
  }

  .group {
    z-index: var(--n-layer-max);
    position: fixed;
    overflow-y: auto;
    width: var(--n-toast-container-width);
    min-width: min(var(--n-toast-container-width-min), 100vi);
    max-height: calc(100dvh - var(--n-toast-container-padding) * 2);
    padding: var(--n-toast-container-padding);
    pointer-events: none; /* Allow clicking through the container */

    @media (--mq-sm) {
      max-width: var(--n-toast-container-width-max);
    }
  }

  .group > * {
    pointer-events: auto; /* But enable clicking on actual toasts */
  }

  /* POSITIONS -------------------------------------------------------------- */

  .topLeftPosition {
    top: 0;
    left: 0;
    flex-direction: column-reverse;
  }

  .topCenterPosition {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column-reverse;
  }

  .topRightPosition {
    top: 0;
    right: 0;
    flex-direction: column-reverse;
  }

  .bottomRightPosition {
    bottom: 0;
    right: 0;
    flex-direction: column;
  }

  .bottomCenterPosition {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
  }

  .bottomLeftPosition {
    bottom: 0;
    left: 0;
    flex-direction: column;
  }
}
